import { doGet, doPut, doPost, doDelete } from './common';

const getList = (pagination = undefined, sort = undefined, keyword = undefined) => {
  let filter = '';
  if (pagination) {
    filter = `?limit=${pagination.limit}&offset=${pagination.offset}`;
  }
  if (sort) {
    if (filter !== '') filter += `&sort=${sort}`;
    else filter = `?sort=${sort}`;
  }
  if (keyword) {
    if (filter !== '') filter += `&keyword=${keyword}`;
    else filter = `?keyword=${keyword}`;
  }
  return doGet(`/api/buyer${filter}`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}

const getStatYear = (id, year) => {
  return doGet(`/api/buyer/${id}/stat/${year}`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}
const getListCount = (keyword) => {
  let filter = '';
  if (keyword) {
    filter = `?keyword=${keyword}`;
  }
  return doGet(`/api/buyer/count${filter}`).then(res => (res.data.count))
    .catch(err => { })
    .finally(() => {

    });
}

const getListEnabled = () => {
  return doGet(`/api/buyer`).then(res => (res.data.filter(x => x.enabled === true)))
    .catch(err => { })
    .finally(() => {

    });
}

const getById = (id) => {
  return doGet(`/api/buyer/${id}`)
    .catch(err => { })
    .finally(() => {

    });
}

const insert = (params) => {
  return doPost(`/api/buyer`, params).then(res => (res.data)
  ).catch(err => {

  }).finally(() => {

  });
}

const update = (id, params) => {
  return doPut(`/api/buyer/${id}`, params).then(res => (res.data)
  ).catch(err => {

  }).finally(() => {

  });
}

const checkCanDelete = (id) => {
  return doGet(`/api/buyer/${id}/used`).then(res => (res.data)
  ).catch(err => {

  }).finally(() => {

  });
}

const deleteById = (id) => {
  return doDelete(`/api/buyer/${id}`).then(data => (
    {

    }
  )).catch(err => {

  }).finally(() => {

  });
}

const insertGoods = (id, params, callback) => {
  return doPost(`/api/buyer/${id}/goods`, params).then(res => {
    callback && callback(res.data);
    return res.data;
  }).catch(err => {

  }).finally(() => {

  });
}

const getGoodsBySpecName = (id, goods_spec_name) => {
  return doGet(`/api/buyer/${id}/goods/spec/${goods_spec_name}`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}

const getGoodsList = (id) => {
  return doGet(`/api/buyer/${id}/goods`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}

const getGoodsAndPriceList = (id) => {
  return doGet(`/api/buyer/${id}/goods/price/realtime`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}

const getGoodsListByDatetime = (id, datetime) => {
  return doGet(`/api/buyer/${id}/goods/${datetime}`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}

const checkCanDeleteGoods = (buyer_id, goods_id, goods_spec_id) => {
  return doGet(`/api/buyer/${buyer_id}/goods/${goods_id}/spec/${goods_spec_id}/used`).then(res => (res.data)
  ).catch(err => {

  }).finally(() => {

  });
}

const deleteGoods = (buyer_id, goods_id, goods_spec_id) => {
  return doDelete(`/api/buyer/${buyer_id}/goods/${goods_id}/spec/${goods_spec_id}`).then(res => (res.data)
  ).catch(err => {

  }).finally(() => {

  });
}
const getGoodsPriceList = (id) => {
  return doGet(`/api/buyer/${id}/goods/price`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}

const getGoodsSpecPriceList = (buyer_id, goods_id, goods_spec_id) => {
  return doGet(`/api/buyer/${buyer_id}/goods/${goods_id}/spec/${goods_spec_id}/price`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}

const insertGoodsPrice = (buyer_id, goods_id, goods_spec_id, params) => {
  return doPost(`/api/buyer/${buyer_id}/goods/${goods_id}/spec/${goods_spec_id}/price`, params).then(res => (res.data)
  ).catch(err => {

  }).finally(() => {

  });
}

const updateGoodsPrice = (buyer_id, goods_id, goods_spec_id, params) => {
  return doPut(`/api/buyer/${buyer_id}/goods/${goods_id}/spec/${goods_spec_id}/price`, params).then(res => (res.data)
  ).catch(err => {

  }).finally(() => {

  });
}

const updatePackageSize = (buyer_id, goods_id, goods_spec_id, params) => {
  return doPut(`/api/buyer/${buyer_id}/goods/${goods_id}/spec/${goods_spec_id}/package/size`, params).then(res => (res.data)
  ).catch(err => {

  }).finally(() => {

  });
}

const getOrderPendingByBuyerId = (id) => {
  return doGet(`/api/buyer/${id}/order`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}

const getNotifyPartById = (id) => {
  return doGet(`/api/buyer/${id}/notify/party`).then(res => (res.data))
  .catch(err => { })
  .finally(() => {

  });
}
const insertNotifyParty = (id, params) => {
  return doPost(`/api/buyer/${id}/notify/party`, params).then(res => (res.data)
  ).catch(err => {

  }).finally(() => {

  });
}
const downloadTemplate = () => {
  return doGet(`/api/buyer/template/download`, null, 'blob').then(res => (res.data))
  .catch(err => { })
  .finally(() => {

  });
}

const downloadData = () => {
  return doGet(`/api/buyer/download`, null, 'blob').then(res => (res.data))
  .catch(err => { })
  .finally(() => {

  });
}
export {
  getList,
  getListCount,
  getListEnabled,
  getById,
  update,
  insert,
  deleteById,
  checkCanDelete,
  getStatYear,
  insertGoods,
  checkCanDeleteGoods,
  deleteGoods,
  getGoodsBySpecName,
  getGoodsList,
  getGoodsAndPriceList,
  getGoodsListByDatetime,
  getGoodsPriceList,
  getGoodsSpecPriceList,
  insertGoodsPrice,
  updateGoodsPrice,
  getOrderPendingByBuyerId,
  getNotifyPartById,
  insertNotifyParty,
  updatePackageSize,
  downloadTemplate,
  downloadData
}